/**
 * Owner: Masa Bayu
 * File: PwaShellUpdateBanner.tsx
 * Date:Time: 2026-09-22 06:02
 * Description: PWA-Phase-A App update banner — Plane S · ≠ publication tip.
 */

import { QxButton } from '../ui01';
import type { PwaShellUpdateView } from './shell-update';

export interface PwaShellUpdateBannerProps {
  readonly update: PwaShellUpdateView;
  readonly onUpdate: () => void;
  readonly onLater: () => void;
}

export function PwaShellUpdateBanner({
  update,
  onUpdate,
  onLater,
}: PwaShellUpdateBannerProps) {
  if (update.state !== 'update_available' && update.state !== 'failed') {
    return null;
  }
  return (
    <div
      className="qx-pwa-shell-update"
      data-pwa-phase-a="shell-update"
      data-pwa-shell-update={update.state}
      role="status"
      aria-live="polite"
    >
      <div className="qx-pwa-shell-update__copy">
        <strong>{update.title}</strong>
        <p>{update.body}</p>
      </div>
      <div className="qx-pwa-shell-update__actions">
        {update.state === 'update_available' ? (
          <QxButton variant="primary" onClick={onUpdate}>
            Update app
          </QxButton>
        ) : null}
        <QxButton variant="ghost" onClick={onLater}>
          Later
        </QxButton>
      </div>
    </div>
  );
}
